import { cn } from "@/lib/utils";

function MarkerIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5.5 text-dark-raspberry", className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.857 9.857C18.857 14.844 12 21 12 21S5.143 14.844 5.143 9.857a6.857 6.857 0 0113.714 0z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="12"
        cy="9.769"
        r="2.5"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default MarkerIcon;
